import { Layout } from 'antd';
import { GithubOutlined, LinkedinOutlined } from '@ant-design/icons';

const { Footer: AntFooter } = Layout;

export const Footer = () => {
  return (
    <AntFooter className="footer">
      <div className="footer-content">
        <div className="social-links">
          <a
            href="https://www.linkedin.com/in/LarissaMorrell/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <LinkedinOutlined />
          </a>
          <a
            href="https://github.com/LarissaMorrell"
            target="_blank"
            rel="noopener noreferrer"
          >
            <GithubOutlined />
          </a>
        </div>
        <div className="copyright">
          © {new Date().getFullYear()} Larissa Morrell
        </div>
      </div>
    </AntFooter>
  );
};

export default Footer;